import React from "react";
import styled, { css } from "styled-components";

interface Props {
  required?: boolean;
  label: React.ReactNode;
  className?: string;
  hasValue?: boolean;
}

const StyledLabel = styled.label`
  color: var(--gray300);
  cursor: auto;
  font-size: 14.5px;
  padding-bottom: 5px;
  display: flex;
  align-items: center;
`;

const LabelText = styled.span`
  padding-right: 5px;
`;

const Required = styled.span<{ $hasValue?: boolean }>`
  color: var(--red400);
  padding-left: 5px;

  ${(props) =>
    props.$hasValue &&
    css`
      color: var(--gray100);
    `}
`;

const Label = (props: Props) => {
  const { label, required, className, hasValue } = props;

  return (
    <StyledLabel className={className}>
      <LabelText>{label}</LabelText>
      {required && (
        <Required $hasValue={hasValue !== false}>(Required)</Required>
      )}
      {required === false && <Required $hasValue>(Optional)</Required>}
    </StyledLabel>
  );
};

export default Label;
